import React from "react";
import icon from "../../images/icon.svg"
import "../../style/TeamChatSidebar.css"
import chaticon from "../../images/chaticon.png"
import { useNavigate } from "react-router-dom";
// const icon = require("https://cdn-icons-png.flaticon.com/512/14/14558.png")


function SideChat() {
    const navigate = useNavigate()

  return (
    
        <div style={{position:"fixed",top:0,right:0,width:60,height:"200vh", backgroundColor:"#fff", borderLeft:"1px solid #ccc",borderRight:"1px solid #ccc",zIndex:3 }}>
    
        
                <div style={{backgroundColor:'rgb(17, 24, 39)', display:'flex', justifyContent:'center', alignItems:"center", height:55}}>
                    <img src={chaticon} alt="Logo" className="brand-image" style={{height:25}}   />
                
                </div>


                <div className="scroll-container" >
                        <div onClick={()=>navigate("/chat")} style={{cursor:'pointer'}}>
                            <div style={{width:20,height:20,backgroundColor:'green',borderRadius:50, color:"#fff", textAlign:'center', position:"relative",zIndex:1}}>2</div>
                            <img src="dist/img/male-16.jpg" className="img-circle elevation-2" alt="User Image" style={{position:'relative',top:-10}}/>
                            <div style={{width:10,height:10,backgroundColor:'green',borderRadius:50, position:'relative',right:-30, top:-20}}>
                            </div>
                        </div>

                        <div onClick={()=>navigate("/chat")} style={{cursor:'pointer'}}>
                            <div style={{width:20,height:20,backgroundColor:'green',borderRadius:50, color:"#fff", textAlign:'center', position:"relative",zIndex:1}}>2</div>
                            <img src="dist/img/1.jpg" className="img-circle elevation-2" alt="User Image" style={{position:'relative',top:-10}}/>
                            <div style={{width:10,height:10,backgroundColor:'green',borderRadius:50, position:'relative',right:-30, top:-20}}>
                            </div>
                        </div>

                        <div onClick={()=>navigate("/chat")} style={{cursor:'pointer'}}>
                            <div style={{width:20,height:20,backgroundColor:'green',borderRadius:50, color:"#fff", textAlign:'center', position:"relative",zIndex:1}}>2</div>
                            <img src="dist/img/2.jpg" className="img-circle elevation-2" alt="User Image" style={{position:'relative',top:-10}}/>
                            <div style={{width:10,height:10,backgroundColor:'green',borderRadius:50, position:'relative',right:-30, top:-20}}>
                            </div>
                        </div>

                        <div onClick={()=>navigate("/chat")} style={{cursor:'pointer'}}>
                            <div style={{width:20,height:20,backgroundColor:'green',borderRadius:50, color:"#fff", textAlign:'center', position:"relative",zIndex:1}}>2</div>
                            <img src="dist/img/3.jpg" className="img-circle elevation-2" alt="User Image" style={{position:'relative',top:-10}}/>
                            <div style={{width:10,height:10,backgroundColor:'green',borderRadius:50, position:'relative',right:-30, top:-20}}>
                            </div>
                        </div>

                        <div onClick={()=>navigate("/chat")} style={{cursor:'pointer'}}>
                            <div style={{width:20,height:20,backgroundColor:'green',borderRadius:50, color:"#fff", textAlign:'center', position:"relative",zIndex:1}}>2</div>
                            <img src="dist/img/4.jpg" className="img-circle elevation-2" alt="User Image" style={{position:'relative',top:-10}}/>
                            <div style={{width:10,height:10,backgroundColor:'green',borderRadius:50, position:'relative',right:-30, top:-20}}>
                            </div>
                        </div>

                        <div onClick={()=>navigate("/chat")} style={{cursor:'pointer'}}>
                            <div style={{width:20,height:20,backgroundColor:'green',borderRadius:50, color:"#fff", textAlign:'center', position:"relative",zIndex:1}}>2</div>
                            <img src="dist/img/12.jpg" className="img-circle elevation-2" alt="User Image" style={{position:'relative',top:-10}}/>
                            <div style={{width:10,height:10,backgroundColor:'green',borderRadius:50, position:'relative',right:-30, top:-20}}>
                            </div>
                        </div>

                        <div onClick={()=>navigate("/chat")} style={{cursor:'pointer'}}>
                            <div style={{width:20,height:20,backgroundColor:'green',borderRadius:50, color:"#fff", textAlign:'center', position:"relative",zIndex:1}}>2</div>
                            <img src="dist/img/14.jpg" className="img-circle elevation-2" alt="User Image" style={{position:'relative',top:-10}}/>
                            <div style={{width:10,height:10,backgroundColor:'green',borderRadius:50, position:'relative',right:-30, top:-20}}>
                            </div>
                        </div>


                        <div onClick={()=>navigate("/chat")} style={{cursor:'pointer'}}>
                            <div style={{width:20,height:20,backgroundColor:'green',borderRadius:50, color:"#fff", textAlign:'center', position:"relative",zIndex:1}}>2</div>
                            <img src="dist/img/15.jpg" className="img-circle elevation-2" alt="User Image" style={{position:'relative',top:-10}}/>
                            <div style={{width:10,height:10,backgroundColor:'green',borderRadius:50, position:'relative',right:-30, top:-20}}>
                            </div>
                        </div>

                        <div onClick={()=>navigate("/chat")} style={{cursor:'pointer'}}>
                            <div style={{width:20,height:20,backgroundColor:'green',borderRadius:50, color:"#fff", textAlign:'center', position:"relative",zIndex:1}}>2</div>
                            <img src="dist/img/14.jpg" className="img-circle elevation-2" alt="User Image" style={{position:'relative',top:-10}}/>
                            <div style={{width:10,height:10,backgroundColor:'green',borderRadius:50, position:'relative',right:-30, top:-20}}>
                            </div>
                        </div>

                        <div onClick={()=>navigate("/chat")} style={{cursor:'pointer'}}>
                            <div style={{width:20,height:20,backgroundColor:'green',borderRadius:50, color:"#fff", textAlign:'center', position:"relative",zIndex:1}}>2</div>
                            <img src="dist/img/male-02.jpg" className="img-circle elevation-2" alt="User Image" style={{position:'relative',top:-10}}/>
                            <div style={{width:10,height:10,backgroundColor:'green',borderRadius:50, position:'relative',right:-30, top:-20}}>
                            </div>
                        </div>

                        <div onClick={()=>navigate("/chat")} style={{cursor:'pointer'}}>
                            <div style={{width:20,height:20,backgroundColor:'green',borderRadius:50, color:"#fff", textAlign:'center', position:"relative",zIndex:1}}>2</div>
                            <img src="dist/img/male-04.jpg" className="img-circle elevation-2" alt="User Image" style={{position:'relative',top:-10}}/>
                            <div style={{width:10,height:10,backgroundColor:'green',borderRadius:50, position:'relative',right:-30, top:-20}}>
                            </div>
                        </div>


                        <div onClick={()=>navigate("/chat")} style={{cursor:'pointer'}}>
                            <div style={{width:20,height:20,backgroundColor:'green',borderRadius:50, color:"#fff", textAlign:'center', position:"relative",zIndex:1}}>2</div>
                            <img src="dist/img/12.jpg" className="img-circle elevation-2" alt="User Image" style={{position:'relative',top:-10}}/>
                            <div style={{width:10,height:10,backgroundColor:'green',borderRadius:50, position:'relative',right:-30, top:-20}}>
                            </div>
                        </div>

                        <div onClick={()=>navigate("/chat")} style={{cursor:'pointer'}}>
                            <div style={{width:20,height:20,backgroundColor:'green',borderRadius:50, color:"#fff", textAlign:'center', position:"relative",zIndex:1}}>2</div>
                            <img src="dist/img/13.jpg" className="img-circle elevation-2" alt="User Image" style={{position:'relative',top:-10}}/>
                            <div style={{width:10,height:10,backgroundColor:'green',borderRadius:50, position:'relative',right:-30, top:-20}}>
                            </div>
                        </div>

                        <div onClick={()=>navigate("/chat")} style={{cursor:'pointer'}}>
                            <div style={{width:20,height:20,backgroundColor:'green',borderRadius:50, color:"#fff", textAlign:'center', position:"relative",zIndex:1}}>2</div>
                            <img src="dist/img/14.jpg" className="img-circle elevation-2" alt="User Image" style={{position:'relative',top:-10}}/>
                            <div style={{width:10,height:10,backgroundColor:'green',borderRadius:50, position:'relative',right:-30, top:-20}}>
                            </div>
                        </div>

                        <div onClick={()=>navigate("/chat")} style={{cursor:'pointer'}}>
                            <div style={{width:20,height:20,backgroundColor:'green',borderRadius:50, color:"#fff", textAlign:'center', position:"relative",zIndex:1}}>2</div>
                            <img src="dist/img/15.jpg" className="img-circle elevation-2" alt="User Image" style={{position:'relative',top:-10}}/>
                            <div style={{width:10,height:10,backgroundColor:'green',borderRadius:50, position:'relative',right:-30, top:-20}}>
                            </div>
                        </div>

                        <div onClick={()=>navigate("/chat")} style={{cursor:'pointer'}}>
                            <div style={{width:20,height:20,backgroundColor:'green',borderRadius:50, color:"#fff", textAlign:'center', position:"relative",zIndex:1}}>2</div>
                            <img src="dist/img/male-06.jpg" className="img-circle elevation-2" alt="User Image" style={{position:'relative',top:-10}}/>
                            <div style={{width:10,height:10,backgroundColor:'green',borderRadius:50, position:'relative',right:-30, top:-20}}>
                            </div>
                        </div>

                        <div onClick={()=>navigate("/chat")} style={{cursor:'pointer'}}>
                            <div style={{width:20,height:20,backgroundColor:'green',borderRadius:50, color:"#fff", textAlign:'center', position:"relative",zIndex:1}}>2</div>
                            <img src="dist/img/male-16.jpg" className="img-circle elevation-2" alt="User Image" style={{position:'relative',top:-10}}/>
                            <div style={{width:10,height:10,backgroundColor:'green',borderRadius:50, position:'relative',right:-30, top:-20}}>
                            </div>
                        </div>

                        <div onClick={()=>navigate("/chat")} style={{cursor:'pointer'}}>
                            <div style={{width:20,height:20,backgroundColor:'green',borderRadius:50, color:"#fff", textAlign:'center', position:"relative",zIndex:1}}>2</div>
                            <img src="dist/img/male-17.jpg" className="img-circle elevation-2" alt="User Image" style={{position:'relative',top:-10}}/>
                            <div style={{width:10,height:10,backgroundColor:'green',borderRadius:50, position:'relative',right:-30, top:-20}}>
                            </div>
                        </div>

                        <div onClick={()=>navigate("/chat")} style={{cursor:'pointer'}}>
                            <div style={{width:20,height:20,backgroundColor:'green',borderRadius:50, color:"#fff", textAlign:'center', position:"relative",zIndex:1}}>2</div>
                            <img src="dist/img/male-19.jpg" className="img-circle elevation-2" alt="User Image" style={{position:'relative',top:-10}}/>
                            <div style={{width:10,height:10,backgroundColor:'green',borderRadius:50, position:'relative',right:-30, top:-20}}>
                            </div>
                        </div>

                        <div onClick={()=>navigate("/chat")} style={{cursor:'pointer'}}>
                            <div style={{width:20,height:20,backgroundColor:'green',borderRadius:50, color:"#fff", textAlign:'center', position:"relative",zIndex:1}}>2</div>
                            <img src="dist/img/male-02.jpg" className="img-circle elevation-2" alt="User Image" style={{position:'relative',top:-10}}/>
                            <div style={{width:10,height:10,backgroundColor:'green',borderRadius:50, position:'relative',right:-30, top:-20}}>
                            </div>
                        </div>

                        <div onClick={()=>navigate("/chat")} style={{cursor:'pointer'}}>
                            <div style={{width:20,height:20,backgroundColor:'green',borderRadius:50, color:"#fff", textAlign:'center', position:"relative",zIndex:1}}>2</div>
                            <img src="dist/img/male-04.jpg" className="img-circle elevation-2" alt="User Image" style={{position:'relative',top:-10}}/>
                            <div style={{width:10,height:10,backgroundColor:'green',borderRadius:50, position:'relative',right:-30, top:-20}}>
                            </div>
                        </div>

                        <div onClick={()=>navigate("/chat")} style={{cursor:'pointer'}}>
                            <div style={{width:20,height:20,backgroundColor:'green',borderRadius:50, color:"#fff", textAlign:'center', position:"relative",zIndex:1}}>2</div>
                            <img src="dist/img/male-05.jpg" className="img-circle elevation-2" alt="User Image" style={{position:'relative',top:-10}}/>
                            <div style={{width:10,height:10,backgroundColor:'green',borderRadius:50, position:'relative',right:-30, top:-20}}>
                            </div>
                        </div>

                        <div onClick={()=>navigate("/chat")} style={{cursor:'pointer'}}>
                            <div style={{width:20,height:20,backgroundColor:'green',borderRadius:50, color:"#fff", textAlign:'center', position:"relative",zIndex:1}}>2</div>
                            <img src="dist/img/male-06.jpg" className="img-circle elevation-2" alt="User Image" style={{position:'relative',top:-10}}/>
                            <div style={{width:10,height:10,backgroundColor:'green',borderRadius:50, position:'relative',right:-30, top:-20}}>
                            </div>
                        </div>

                        <div onClick={()=>navigate("/chat")} style={{cursor:'pointer'}}>
                            <div style={{width:20,height:20,backgroundColor:'green',borderRadius:50, color:"#fff", textAlign:'center', position:"relative",zIndex:1}}>2</div>
                            <img src="dist/img/male-16.jpg" className="img-circle elevation-2" alt="User Image" style={{position:'relative',top:-10}}/>
                            <div style={{width:10,height:10,backgroundColor:'green',borderRadius:50, position:'relative',right:-30, top:-20}}>
                            </div>
                        </div>

                        <div onClick={()=>navigate("/chat")} style={{cursor:'pointer'}}>
                            <div style={{width:20,height:20,backgroundColor:'green',borderRadius:50, color:"#fff", textAlign:'center', position:"relative",zIndex:1}}>2</div>
                            <img src="dist/img/male-17.jpg" className="img-circle elevation-2" alt="User Image" style={{position:'relative',top:-10}}/>
                            <div style={{width:10,height:10,backgroundColor:'green',borderRadius:50, position:'relative',right:-30, top:-20}}>
                            </div>
                        </div>

                    
                    
                    
                </div>  
        
        </div>
    
  );
}

export default SideChat;
